import React, { Suspense } from 'react'
import Card from '../../../../../../components/Card'
import Body from './Body'
import { Table } from '@imcva/reactstrap-table'
import { columns } from './columns'
import { faArrowUpRightFromSquare, faPlus } from '@fortawesome/free-solid-svg-icons'
import { Link } from 'react-router-dom'
import AddCandidateModal from 'src/components/SharedModals/AddCandidateModal'
import useToggleState from 'src/hooks/useToggleState'

interface CandidatesProps {
  id: number
}

const Candidates: React.FC<CandidatesProps> = (props) => {
  const { id } = props
  const [isOpen, , handleToggle] = useToggleState()

  return (
    <>
      <Card
        title='Candidates'
        titleAction={{
          key: 'candidate-details',
          icon: faArrowUpRightFromSquare,
          tag: Link,
          to: 'candidates'
        }}
        primaryAction={{
          key: 'add',
          icon: faPlus,
          text: 'Add Candidate',
          onClick: handleToggle,
          permissionKey: 'CAT_EDIT'
        }}
      >
        <Suspense fallback={<Table options={{ data: [], columns }} suspend={3} />}>
          <Body id={id} />
        </Suspense>
      </Card>
      <AddCandidateModal position={id} isOpen={isOpen} toggle={handleToggle} />
    </>
  )
}

export default Candidates
